/**
 * Mobile category drawer — left slide-in menu (≤989px only).
 */
(function () {
  const MOBILE_MQ = window.matchMedia('(max-width: 989px)');
  const PANEL_TRANSITION_MS = 480;

  /** @type {HTMLElement | null} */
  let activeDrawer = null;
  /** @type {HTMLElement | null} */
  let activeToggle = null;

  const getFocusable = function (panel) {
    return panel.querySelectorAll(
      'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
  };

  const clearDrawerCloseTimer = function (drawer) {
    if (!drawer || !drawer.dataset.closeTimer) return;
    window.clearTimeout(Number(drawer.dataset.closeTimer));
    drawer.dataset.closeTimer = '';
  };

  const setDrawerOpen = function (drawer, toggle, isOpen) {
    if (!drawer) return;

    clearDrawerCloseTimer(drawer);

    if (isOpen) {
      drawer.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('is-mobile-category-drawer-open');

      if (toggle) {
        toggle.setAttribute('aria-expanded', 'true');
      }

      void drawer.offsetWidth;

      window.requestAnimationFrame(function () {
        drawer.classList.add('is-open');
      });

      activeDrawer = drawer;
      activeToggle = toggle;

      const panel = drawer.querySelector('.editorial-mobile-category-drawer__panel');
      const focusables = panel ? getFocusable(panel) : [];
      if (focusables.length) {
        window.setTimeout(function () {
          focusables[0].focus();
        }, PANEL_TRANSITION_MS * 0.35);
      }

      return;
    }

    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-mobile-category-drawer-open');

    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
    }

    if (activeDrawer === drawer) {
      activeDrawer = null;
      activeToggle = null;
    }

    const closeTimerId = window.setTimeout(function () {
      drawer.hidden = true;
      drawer.dataset.closeTimer = '';
    }, PANEL_TRANSITION_MS);

    drawer.dataset.closeTimer = String(closeTimerId);

    if (toggle) {
      window.setTimeout(function () {
        toggle.focus();
      }, PANEL_TRANSITION_MS * 0.5);
    }
  };

  const closeActiveDrawer = function () {
    if (!activeDrawer) return;
    const toggle = activeToggle;
    setDrawerOpen(activeDrawer, toggle, false);
  };

  const initToggle = function (toggle) {
    if (!toggle || toggle.dataset.mobileCategoryToggleInitialized === 'true') return;
    toggle.dataset.mobileCategoryToggleInitialized = 'true';

    const controlsId = toggle.getAttribute('aria-controls');
    const drawer = controlsId ? document.getElementById(controlsId) : null;
    if (!drawer) return;

    toggle.addEventListener('click', function (event) {
      if (!MOBILE_MQ.matches) return;

      event.preventDefault();
      event.stopPropagation();

      const willOpen = !drawer.classList.contains('is-open');
      if (willOpen && activeDrawer && activeDrawer !== drawer) {
        setDrawerOpen(activeDrawer, activeToggle, false);
      }
      setDrawerOpen(drawer, toggle, willOpen);
    });
  };

  const initDrawer = function (drawer) {
    if (!drawer || drawer.dataset.mobileCategoryDrawerInitialized === 'true') return;
    drawer.dataset.mobileCategoryDrawerInitialized = 'true';

    drawer.querySelectorAll('[data-mobile-category-close]').forEach(function (closeBtn) {
      closeBtn.addEventListener('click', function (event) {
        event.preventDefault();
        const toggle = activeToggle;
        setDrawerOpen(drawer, toggle, false);
      });
    });
  };

  const boot = function () {
    document.querySelectorAll('[data-mobile-category-toggle]').forEach(initToggle);
    document.querySelectorAll('[data-mobile-category-drawer]').forEach(initDrawer);
  };

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && activeDrawer) {
      event.preventDefault();
      closeActiveDrawer();
    }
  });

  if (typeof MOBILE_MQ.addEventListener === 'function') {
    MOBILE_MQ.addEventListener('change', function () {
      if (!MOBILE_MQ.matches) {
        closeActiveDrawer();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
